<script>
    import { createEventDispatcher } from "svelte";
    import DTInputCell from "../common/DTInputCell.svelte";
    import IconButton, { Icon } from "@smui/icon-button";
    import DataTable, { Head, Body, Row, Cell, Label } from "@smui/data-table";
    import Tooltip, { Wrapper, Content } from "@smui/tooltip";
    import { mdiContentSaveOutline, mdiContentSave, mdiCloseThick, mdiPencilBoxOutline } from "@mdi/js";
    import { _ } from "svelte-i18n";
    import { formatVolume, isNumber, convertToEur, formatPrice } from "../lib/Functions";
    import { onMount } from 'svelte';
    import { maxPrice, minPrice, maxPriceEur, minPriceEur } from "../../../stores/AppConfig";

    export let value;
    export let valueConv;
    export let writable = false;
    export let deleted = false;
    export let rowStyle = "";
    export let currency = "EUR";
    export let type = "regular";
    export let editDisabled = false;
    export let bold = true;
    export let alwaysShowConvValue = true;
 
    let oldValue = 0;
    let valueInvalid = false;
    let editing = false;


    const dispatch = createEventDispatcher();

    onMount(() => {
        oldValue = value;
        editing = false;
    })

    $: {
        if (type == "promo" && (!value || value == null || value == "" || (isNumber(String(value).replaceAll(',','.')) && Number(String(value).replaceAll(',','.')) === 0))) {
            valueInvalid = false;
        }  else if (value &&
                       isNumber(String(value).replaceAll(',','.')) && 
                       Number(String(value).replaceAll(',','.')).countDecimals() <= 2 &&
                       (type == "promo")?
                        (currency == "EUR"? (Number(String(value).replaceAll(',','.')) >= 0 && Number(String(value).replaceAll(',','.')) <= maxPriceEur): (Number(String(value).replaceAll(',','.')) >= 0 && Number(String(value).replaceAll(',','.')) <= maxPrice)):
                        (currency == "EUR"? (Number(String(value).replaceAll(',','.')) >= minPriceEur && Number(String(value).replaceAll(',','.')) <= maxPriceEur): (Number(String(value).replaceAll(',','.')) >= minPrice && Number(String(value).replaceAll(',','.')) <= maxPrice))) {
           valueInvalid = false;
        } else {
          valueInvalid = true;
        }
    }
    $: valueConv = !valueInvalid? convertToEur(Number(String(value).replaceAll(',','.')), currency): "";
    $: saveDisabled = (valueInvalid || Number(String(value).replaceAll(',','.')) == oldValue);

    /*
    function displayPrice(price, currency, priceEur) {
        return !priceEur || priceEur == price ? `${price} ${currency}` : `${price} ${currency} (${priceEur} EUR)`;
    }


    function validateChanges() {
        console.log("==================== validateChanges =====================",{value}, {currency});
        if (!loading) {
            if (!valueInvalid)  {
                let val = Number(String(value).replaceAll(',','.'));
                if ((val != oldValue)) {
                }
            }
        }
    }
*/
    function handleKeyEvent(event){
        if (event.key === 'Escape') {
            value = oldValue;
            editing = false;
            dispatch("finishEdit");
        }
    }

    function handleSaveButton() {
        if (valueInvalid || saveDisabled) {
            value = oldValue;
            editing = false;
            dispatch("finishEdit");
        } else {
            saveChange();
        }
    }

    function handleFocus (event) {
        //console.log("==================== handleFocus =====================", event.target);
        //event.target.select(); // Throws exception !!!
    }

    function saveChange() {
        console.log("==================== saveChange =====================",{value}, {valueConv}, {oldValue}, {currency});
        if (!valueInvalid)  {
            let val = Number(String(value).replaceAll(',','.'));
            oldValue = val;
            value = String(val);
            editing = false;
            dispatch("valueChanged", { value: val, valueConv: valueConv });
            dispatch("finishEdit");
        }
    }

</script>

{#if writable}
    <Cell numeric class="{rowStyle} right-splitter-sub noborder " style="max-width: 8em; ">
        {#if editing}
                <div class="{rowStyle} datatable-cell " style="justify-content: end; display: inline">
                    <DTInputCell
                        bind:value={value}
                        editable={writable}
                        autofocus={false}
                        class="small {deleted ? 'row-deleted' : ''}"
                        extraClasses="{bold? "inline-price-edit-bold": "inline-price-edit"} white-bg "
                        withTrailingIcon={false}
                        {valueInvalid}
                        ignoreFocus={true}
                        on:keyup={handleKeyEvent}
                        on:focus={handleFocus}
                    />
                    <!--<IconButton size="button" class="tescoblue-text opacity-1" title="{valueInvalid? "cancel":$_('save_'+ (type=="promo"? "promo_":"")+'price_change')}" disabled={saveDisabled && !valueInvalid} on:click="{handleSaveButton}">-->
                    <IconButton size="button" class="tescoblue-text opacity-1" title="{(valueInvalid || saveDisabled)? "cancel":$_('save_'+ (type=="promo"? "promo_":"")+'price_change')}" on:click="{handleSaveButton}">
                        <Icon tag="svg" viewBox="0 0 24 24" class="{saveDisabled? (valueInvalid? "tescored-text":"tescored-text"):"green-text"}">
                            {#if saveDisabled}
                                {#if valueInvalid}
                                    <path fill="currentColor" d={mdiCloseThick} />
                                {:else}
                                    <path fill="currentColor" d={mdiCloseThick} />
                                    <!--<path fill="currentColor" d={mdiContentSaveOutline} />-->
                                {/if}
                            {:else}
                                    <path fill="currentColor" d={mdiContentSave} />
                            {/if}
                        </Icon>
                    </IconButton>
                </div>
                {#if alwaysShowConvValue || (!alwaysShowConvValue && currency!= "EUR")}
                    <div class=" {deleted ? 'row-deleted' : ''}"><small>{formatPrice(valueConv)} EUR</small></div>
                {/if}
        {:else}
            <div class="cell-contents">
                <span class="edit" style="display:block" >
                    <IconButton size="normal" class="tescoblue-text opacity-1" disabled="{editDisabled}" on:click="{(e) => {editing = true; dispatch("startEdit");}}" title="{$_('click_to_edit')}" >
                        <Icon tag='svg' viewBox="0 0 25 25" class=" {editDisabled? "grey-text": "tescoblue-text"}" style="height: 2rem; opacity: .9;">
                            <path fill="currentColor" d={mdiPencilBoxOutline } />
                        </Icon>
                    </IconButton>
                </span>
                <span class="">
                    <span class="{bold? "text-bold":""}">{value?? ""}</span>
                    {#if alwaysShowConvValue || (!alwaysShowConvValue && currency!= "EUR")}
                        <br />
                        <div class="{deleted ? 'row-deleted' : ''}"><small>{valueConv? formatPrice(valueConv) + " EUR": ""}</small></div>
                    {/if}
                </span>
            </div>
        {/if}
    </Cell>
{:else}
    <Cell numeric class="{rowStyle} right-splitter-sub">
        <span class="{bold? "text-bold":""} {deleted ? "row-deleted" : ""}">{value?? ""}</span>
        {#if alwaysShowConvValue || (!alwaysShowConvValue && currency!= "EUR")}
            <br />
            <div class="{deleted ? 'row-deleted' : ''}"><small>{valueConv? formatPrice(valueConv) + " EUR": ""}</small></div>
        {/if}
    </Cell>
{/if}

<style>
    .datatable-cell {
        border-bottom: 0px !important;
    }
    .converted-value {
        font-size: 1em;
        color: gray;
        text-align: right;
    }
    .cell-contents {
        display: flex;
        flex-direction: row;
        justify-content:space-between;
        align-items:center;
    }
</style>
